/**
 * Настройки наценок ЛК: типы цен, правила, сопоставление с типами цен 1С и выбор
 * типов по разделам. Хранятся на сервере в настройках пользователя Eplex API
 * (`settings/common`, ключ `lk.markup`) — с CAB-778 браузер их не хранит.
 */

export type Rounding = "none" | "0.01" | "0.1" | "1" | "10" | "100" | "1000";

export const ROUNDING_VALUES: readonly Rounding[] = ["none", "0.01", "0.1", "1", "10", "100", "1000"];

export interface PriceType {
  id: string;
  name: string;
}

export interface MarginRule {
  id: string;
  typeId: string;
  /** 0 — правило «по умолчанию», для всех поставщиков. */
  pluginId: number;
  /** «Цена от»: правило действует на цены не ниже порога. */
  threshold: number;
  percent: number;
  enabled: boolean;
}

/** Версия формата записи на сервере: при смене структуры читать старую и писать новую. */
export const MARKUP_SETTINGS_VERSION = 1;

/**
 * Запись на сервере целиком. Пишется одним PATCH по пути `lk.markup`, поэтому здесь
 * только то, что должно переезжать между устройствами: активная строка таблицы
 * настроек (UI одного экрана) сюда не входит.
 */
export interface MarkupSettingsSnapshot {
  version: number;
  rounding: Rounding;
  priceTypes: PriceType[];
  rules: MarginRule[];
  /** Тип цены ЛК → ключи `integration_id||uuid типа цен 1С`, по одному на базу. */
  costTypeMappings: Record<string, string[]>;
  /** Раздел (`singleSearch`, `journal`) → основной тип цен, чья цена идёт в корзину. */
  primaryPriceTypeId: Record<string, string | null>;
  /** Раздел → типы цен, показанные столбцами. */
  selectedPriceTypeIds: Record<string, string[]>;
  /** Когда запись сохранена, ISO-время устройства — для разбора спорных случаев. */
  updatedAt: string;
}
